'use client';

import { clsx } from 'clsx';
import { FC, useRef } from 'react';
import { HeaderLine } from 'organisms/Header/HeaderLine';
import { HEADER_ID } from 'commerce/scayle/constants';
import { PageLoader } from './PageLoader';
import styles from './styles.module.css';

export const SimpleHeader: FC = () => {
  const headerRef = useRef<HTMLDivElement | null>(null);

  return (
    <>
      <PageLoader />
      <header id={HEADER_ID} ref={headerRef} className={clsx(styles.header)}>
        <HeaderLine />
      </header>
    </>
  );
};
